import './VideoButton.css';

function VideoButton() {
  return (
    <section className="videoButton">
      <iframe
        className="videoButton__frame"
        src="https://rutube.ru/play/embed/623aaf2f54ff9326d23939622999eb92"
        title="Интересное видео ВДПО на Rutube"
        allow="clipboard-write; autoplay"
        allowFullScreen
      />
    </section>
  );
}

export default VideoButton;
